module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-base-list"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Total results: " + _vm._s(_vm.data.items_count || _vm.data.items_count === 0 ? _vm.data.items_count : '...loading...'))]), (_vm.data.items_count > 0) ? _vm._t("before") : _vm._e(), _c('div', {
    staticClass: "list-items"
  }, [(_vm.data.items_count === 0) ? _c('h2', {
    staticClass: "no-result-message text-center"
  }, [_vm._v("Nothing to show here yet :(")]) : _vm._e(), (!_vm.data.items) ? _c('loading-spinner') : _vm._e(), (_vm.selectableList) ? _c('div', {
    staticClass: "select-all"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "click": _vm.selectAllCheckboxes,
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  }), _c('label', [_vm._v("Select all")])]) : _vm._e(), _vm._l((_vm.data.items), function(item, i) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item",
      class: {
        'list-odd': i % 2, 'flex-list': _vm.selectableList
      }
    }, [(_vm.selectableList) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, item.id) > -1 : (_vm.selected)
      },
      on: {
        "input": function($event) {
          return _vm.checkboxChanged(i, $event.target)
        },
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }) : _vm._e(), _c(_vm.component, {
      tag: "component",
      attrs: {
        "item": item,
        "type": _vm.componentType,
        "id": item.id
      },
      on: {
        "itemUpdated": function($event) {
          return _vm.loadData(1)
        }
      }
    })], 1)
  })], 2), _vm._t("after"), (_vm.showPerPageSelect) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultsPerPageSelect),
      expression: "resultsPerPageSelect"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.resultsPerPageSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setResultsPerPage]
    }
  }, [_c('option', [_vm._v("5")]), _c('option', [_vm._v("10")]), _c('option', [_vm._v("25")]), _c('option', [_vm._v("45")]), _c('option', [_vm._v("60")])])]), _c('div', {
    staticClass: "column"
  }, [_c('pagination', {
    attrs: {
      "results": _vm.data.items_count,
      "perPage": _vm.data.per_page_count,
      "currentPage": _vm.currentPage
    },
    on: {
      "pageUpdated": _vm.loadData
    }
  })], 1)]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5b1f2c8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/BaseList.vue
// module id = 2667
// module chunks = 1